(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play/assets/javascripts/fetch-video-analyses.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play/assets/javascripts/fetch-video-analyses.js');
"use strict";


const {
  useVideoAnalyses
} = svs.components.tipsen.hooks;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;

const FetchVideoAnalyses = () => {
  const currentDraw = useCurrentDraw();
  const currentDrawNumber = currentDraw ? currentDraw.drawNumber : null;
  useVideoAnalyses({
    drawNumber: currentDrawNumber,
    autoFetch: Boolean(currentDrawNumber),
    categories: 'stryktipspodden'
  });
  return null;
};
setGlobal('svs.components.tipsen.routePlay.FetchVideoAnalyses', FetchVideoAnalyses);

 })(window);